import type { NounEntry, NounRequest, NounTable } from '../types';

/**
 * Englische Nominalflexion.
 *
 * Deutlich einfacher als im Deutschen: kein Genus, und der Kasus wirkt sich
 * nur im Genitiv aus. Deshalb ignoriert dieser Resolver `case` fuer nom/acc/dat
 * vollstaendig — die englischen Vorlagen im Katalog sind ohnehin eigenstaendig
 * formuliert und brauchen die Unterscheidung nicht.
 */

/** "a" oder "an" — nach Lautung, nicht nach Buchstabe. */
function indefiniteArticle(entry: NounEntry, word: string): string {
  if (entry.an !== undefined) return entry.an ? 'an' : 'a';
  return /^[aeiou]/i.test(word) ? 'an' : 'a';
}

/** Sächsischer Genitiv: "the wreck's", Plural auf -s nur mit Apostroph. */
function possessive(word: string): string {
  return /s$/i.test(word) ? `${word}'` : `${word}'s`;
}

export function renderNounEn(req: NounRequest, nouns: NounTable): string {
  const entry = nouns[req.id];
  if (entry === undefined) {
    return `⟨noun:${req.id}?⟩`;
  }

  let word = req.number === 'pl' ? entry.pl : entry.sg;

  let art: string | null = null;
  if (req.article === 'def') {
    art = 'the';
  } else if (req.article === 'indef' && req.number === 'sg') {
    art = indefiniteArticle(entry, word);
  }

  if (req.case === 'gen') {
    word = possessive(word);
  }

  // Im Englischen gibt es keine Verschmelzung — die Praeposition wird schlicht vorangestellt.
  const parts = [req.prep?.trim(), art, word].filter(
    (p): p is string => p !== undefined && p !== '' && p !== null,
  );

  const phrase = parts.join(' ');
  return req.caps ? phrase.charAt(0).toUpperCase() + phrase.slice(1) : phrase;
}
